import Title from "./Title";

interface PageTitleProps {
  title: string;
  description?: string;
  size?: 1 | 2 | 3 | 4 | 5 | 6;
}

const PageTitle = ({ title, description, size = 2 }: PageTitleProps) => {
  return (
    <div className="mb-6">
      <Title title={title} size={size} />
      {description && (
        <p className="text-muted-foreground text-sm mt-2">{description}</p>
      )}
    </div>
  );
};

export default PageTitle;